export default __webpack_public_path__ + "static/media/talabat.017cb7b4.png";